var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13611 10.4856L3.34632 10.2783C3.48565 10.141 3.71153 10.141 3.85086 10.2783L6.33169 12.7382V7.51837C6.33169 7.32415 6.49143 7.16667 6.68845 7.16667H6.98576C7.18278 7.16667 7.34252 7.32415 7.34252 7.51837V12.7382L9.82335 10.2783C9.96266 10.141 10.1885 10.141 10.3279 10.2783L10.5381 10.4856C10.6774 10.6229 10.6774 10.8456 10.5381 10.9829L7.08938 14.397C6.95005 14.5343 6.72417 14.5343 6.58481 14.397L3.13608 10.9829C2.99678 10.8456 2.99678 10.6229 3.13611 10.4856Z",
    fill: "#1752AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.877 3.9082L10.1211 1.20117C9.82227 0.911133 9.39062 0.75 8.99219 0.75H2.21875C1.32227 0.75 0.625 1.45898 0.625 2.29688V15.7031C0.625 16.5732 1.32227 17.25 2.21875 17.25H11.7812C12.6445 17.25 13.375 16.5732 13.375 15.7031V5.00391C13.375 4.61719 13.1758 4.19824 12.877 3.9082ZM12.1465 4.64941C12.2129 4.71387 12.2461 4.81055 12.2793 4.875H9.125V1.81348C9.19141 1.8457 9.29102 1.87793 9.35742 1.94238L12.1465 4.64941ZM11.7812 16.2188H2.21875C1.91992 16.2188 1.6875 15.9932 1.6875 15.7031V2.29688C1.6875 2.03906 1.91992 1.78125 2.21875 1.78125H8.0625V5.13281C8.0625 5.58398 8.39453 5.90625 8.85937 5.90625H12.3125V15.7031C12.3125 15.9932 12.0469 16.2188 11.7812 16.2188Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/DownloadIcon.4c232a144ca519c00cf962793d45a933.svg";
export { ForwardRef as ReactComponent };